import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { NodeTextField, NODE_UI } from "../../NodeUI";
import PlanStepCard from "./PlanStepCard";

export default function PlanTemplateEditor({
  goal = "",
  tasks = [],
  onGoalChange,
  onStepChange,
  onStepRemove,
  onAddStep,
  goalLabel = "Overall goal",
  goalHelperText,
  stepsHelperText,
  sx,
}) {
  const steps = tasks || [];

  return (
    <Box sx={sx}>
      <NodeTextField
        label={goalLabel}
        fullWidth
        multiline
        minRows={2}
        value={goal || ""}
        onChange={onGoalChange}
        helperText={goalHelperText}
      />

      {stepsHelperText ? (
        <Typography
          sx={{
            fontSize: NODE_UI.fontSize.caption,
            color: "text.secondary",
            lineHeight: 1.4,
            mt: NODE_UI.spacing.md,
          }}
        >
          {stepsHelperText}
        </Typography>
      ) : null}

      <Stack sx={{ gap: NODE_UI.spacing.md, mt: NODE_UI.spacing.lg }}>
        {steps.map((step, index) => (
          <PlanStepCard
            key={index}
            step={step}
            index={index}
            canRemove={steps.length > 1}
            onChange={(nextStep) => onStepChange(index, nextStep)}
            onRemove={() => onStepRemove(index)}
          />
        ))}
      </Stack>

      <Button
        variant="outlined"
        color="inherit"
        startIcon={<AddOutlinedIcon />}
        onClick={onAddStep}
        sx={{ mt: NODE_UI.spacing.md, alignSelf: "flex-start" }}
      >
        Add step
      </Button>
    </Box>
  );
}
